import {
  GetMeetingDetailsActionTypes,
  GET_MEETING_DETAILS_FAIL,
  GET_MEETING_DETAILS_LOADING,
  GET_MEETING_DETAILS_SUCCESS,
  GetMeetingDetailsState,
  GET_MEETING_DETAILS_API_MSG,
  GET_MEETING_DETAILS_API_RES,
} from "./ActionTypes";
import { GetMeetingDetailsRes } from "./Model";

const initialStateEditPosts: GetMeetingDetailsState = {
  loading: false,
  getMeetingDetailsRes: {} as GetMeetingDetailsRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getMeetingDetailsReducer = (
  state = initialStateEditPosts,
  action: GetMeetingDetailsActionTypes
): GetMeetingDetailsState => {
  switch (action.type) {
    case GET_MEETING_DETAILS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_MEETING_DETAILS_SUCCESS:
      return {
        ...state,
        getMeetingDetailsRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_MEETING_DETAILS_FAIL:
      return {
        ...state,
        getMeetingDetailsRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_MEETING_DETAILS_API_MSG:
      return {
        ...state,
        getMeetingDetailsRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_MEETING_DETAILS_API_RES:
      return {
        ...state,
        getMeetingDetailsRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
